// TODO_PRODUCTION_BLOCKER: las páginas legales públicas no deben publicarse en producción con estos placeholders.
// Sustituir por datos legales reales y validar con asesoría legal antes del despliegue público.
export const MEDSYNC_LEGAL_NAME = '[RAZÓN SOCIAL O NOMBRE LEGAL DE MEDSYNC]';
export const MEDSYNC_LEGAL_ADDRESS = '[DOMICILIO LEGAL]';
export const MEDSYNC_PRIVACY_EMAIL = '[CORREO DE PRIVACIDAD / ARCO]';
export const MEDSYNC_PRIVACY_PHONE = '[TELÉFONO OPCIONAL]';
export const MEDSYNC_LAST_UPDATED = '15 de junio de 2026';
export const MEDSYNC_PRIVACY_DEPARTMENT = '[DEPARTAMENTO O PERSONA DE DATOS PERSONALES]';
export const MEDSYNC_LEGAL_EMAIL = '[CORREO LEGAL / SOPORTE]';
export const MEDSYNC_SUPPORT_EMAIL = '[CORREO LEGAL / SOPORTE]';
export const MEDSYNC_LEGAL_PHONE = '[TELÉFONO OPCIONAL]';
export const MEDSYNC_TERMS_LAST_UPDATED = '15 de junio de 2026';
export const MEDSYNC_SUPPORT_HOURS = '[HORARIO DE SOPORTE PENDIENTE]';
export const MEDSYNC_JURISDICTION = '[JURISDICCIÓN / TRIBUNALES COMPETENTES PENDIENTE DE DEFINIR]';
export const MEDSYNC_APPLICABLE_LAW = '[LEGISLACIÓN APLICABLE Y JURISDICCIÓN PENDIENTE DE DEFINIR CON ASESORÍA LEGAL]';
export const MEDSYNC_RETENTION_EXPORT_POLICY = '[POLÍTICA DE RETENCIÓN Y EXPORTACIÓN PENDIENTE]';
export const MEDSYNC_SLA = '[SLA PENDIENTE DE DEFINIR]';
export const MEDSYNC_BILLING_STATUS = '[PENDIENTE DE DEFINIR COMERCIALMENTE]';

export const TODO_PRODUCTION_BLOCKER = 'Este documento contiene placeholders legales, comerciales y operativos pendientes de confirmar; no debe publicarse productivamente sin revisión legal.';
